// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3Eitm","rootSmall":"AddTileButton_rootSmall__LWheI"};